const variant = {
  emoji: 'emoji',
  'numeric-5': 'numeric-5',
  'numeric-10': 'numeric-10'
};

export { variant as v };
//# sourceMappingURL=variant-K-YUik8y.js.map
